// extracted by mini-css-extract-plugin
export default {"containerError":"styles_containerError__Eh0lO","textError":"styles_textError__NWGpI","errorIcon":"styles_errorIcon__koM81"};